// ! create ls -lia like structure to display on site
export const Ls = (
  <div className="grid grid-cols-9 place-items-start text-sm sm:text-lg">
    {/* Record 1 */}
    <div className="cc-2 col-span-2">-rwxrw-r--</div>
    <div className="cc-2">1</div>
    <div className="cc-2">michkz</div>
    <div className="cc-2">root</div>
    <div className="cc-2">2048</div>
    <div className="cc-2">Sep 10</div>
    <div className="cc-2">21:21</div>
    <div className="cc-3">.</div>
    {/* Record 2 */}
    <div className="cc-2 col-span-2">-rwxrw-r--</div>
    <div className="cc-2">1</div>
    <div className="cc-2">michkz</div>
    <div className="cc-2">root</div>
    <div className="cc-2">2048</div>
    <div className="cc-2">Sep 10</div>
    <div className="cc-2">21:21</div>
    <div className="cc-3">..</div>
    {/* Record 3 */}
    <div className="cc-2 col-span-2">-rwxrw-r--</div>
    <div className="cc-2">1</div>
    <div className="cc-2">michkz</div>
    <div className="cc-2">root</div>
    <div className="cc-2">2048</div>
    <div className="cc-2">Nov 18</div>
    <div className="cc-2">14:38</div>
    <div className="cc-1">education</div>
    {/* Record 4 */}
    <div className="cc-2 col-span-2">-rwxrw-r--</div>
    <div className="cc-2">1</div>
    <div className="cc-2">michkz</div>
    <div className="cc-2">root</div>
    <div className="cc-2">2048</div>
    <div className="cc-2">Nov 19</div>
    <div className="cc-2">15:39</div>
    <div className="cc-1">info</div>
    {/* Record 5 */}
    <div className="cc-2 col-span-2">-rwxrw-r--</div>
    <div className="cc-2">1</div>
    <div className="cc-2">michkz</div>
    <div className="cc-2">root</div>
    <div className="cc-2">2048</div>
    <div className="cc-2">Nov 19</div>
    <div className="cc-2">20:13</div>
    <div className="cc-1">projects</div>
    {/* Record 6 */}
    <div className="cc-2 col-span-2">-rwxrw-r--</div>
    <div className="cc-2">1</div>
    <div className="cc-2">michkz</div>
    <div className="cc-2">root</div>
    <div className="cc-2">2048</div>
    <div className="cc-2">Nov 19</div>
    <div className="cc-2">20:38</div>
    <div className="cc-1">skills</div>
  </div>
);

export default Ls;
